<template>
  <div class="content">
    <p>{{ subtitle }}</p>
    <div style="overflow-x: scroll; overflow-y: hidden">
      <div class="content__block">
        <popular-vacancy-item :items="items" />
      </div>
    </div>
  </div>
</template>

<script>
import PopularVacancyItem from "@/components/main/popularVacancy/modules/PopularVacancyItem.vue";

export default {
  name: "popular-vacancy-block",
  components: { PopularVacancyItem },
  props: {
    subtitle: {
      type: String,
      default: () => "",
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  gap: 24px;

  &__block {
    display: flex;
    gap: 20px;
    width: fit-content;
    margin-bottom: 40px;
  }

  p {
    max-width: 786px;
    font-family: UAF Sans;
    font-weight: 400;
    font-size: 24px;
    line-height: 34px;
  }
}
</style>
